import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import toDollars from 'utils/to-dollars';

import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import { EntityId } from 'services/entities/types';
import TimesheetHolidayGate from 'components/TimesheetHolidayGate';
import { AppState } from 'services/types';
import TableCellTag from 'components/TableCellTag';
import { TIMESHEET_HOLIDAYS_MULTIPLIER } from 'services/timesheetHolidays/constants';

// Selectors
import { makeSelectTimesheetEntryValue } from '../../../../../../../../../../services/timesheetEntries/selectors';

interface OwnProps {
    timesheetEntryUuid: string;
}

interface ConnectedProps {
    rate?: number;
    entityId: EntityId;
    date: TimesheetHolidayDate;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetEntryRateComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { rate, date, entityId } = this.props;
        if (!rate) return null;

        return (
            <TimesheetHolidayGate
                timesheetDate={date}
                timesheetEntityId={entityId}
                fallback={toDollars(rate)}
            >
                <React.Fragment>
                    {toDollars(rate)}
                    <TableCellTag>
                        {` x${TIMESHEET_HOLIDAYS_MULTIPLIER} = ${toDollars(
                            rate * TIMESHEET_HOLIDAYS_MULTIPLIER
                        )}`}
                    </TableCellTag>
                </React.Fragment>
            </TimesheetHolidayGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    rate: makeSelectTimesheetEntryValue('rate'),
    entityId: makeSelectTimesheetEntryValue('entityId'),
    date: makeSelectTimesheetEntryValue('date')
});

export default connect(mapStateToProps)(TimesheetEntryRateComponent);
